(() => {
  if (window.blincCheckoutConsent) return;
  window.blincCheckoutConsent = true;
  function allowCheckout(button, event) {
    const box = button?.closest('[data-blinc-checkout-consent]')?.querySelector('[data-blinc-policy-agreement]');
    if (!box || box.checked) return true;
    event.preventDefault();
    event.stopImmediatePropagation();
    box.setCustomValidity('Please agree to the terms and returns policy before checking out.');
    box.reportValidity();
    box.focus({preventScroll:true});
    return false;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"]');
    if (button) allowCheckout(button, event);
  }, true);
  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (button?.name === 'checkout') allowCheckout(button, event);
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-blinc-policy-agreement]')) event.target.setCustomValidity('');
  });
})();
